<template>
  <div class="quick_wrap">
    <!-- quick_wrap -->
    <a href="javascript:void(0)" @click="quickOpen()" class="quick_open"><span>open</span></a>
    <div class="quick_box h-100" style="right: -362px;">
      <!-- quick_box -->
      <div class="quick_cont">
        <Profile v-if="isShow.profile" @child="getProfileEmitData" ref="quickProfile"></Profile>
        <Link v-if="isShow.link" :user-dmd-info="userDmdInfo" :is-login="isLogin" ref="quickLink"></Link>
        <Menu v-if="isShow.menu" :country-digit-code="countryDigitCode2" @child="getMenuEmitData" ref="quickMenu"></Menu>
        <PromotionSchedule v-if="isShow.promotionschedule" ref="PromotionSchedule"></PromotionSchedule>
        <Schedule v-if="isShow.schedule" ref="quickSchedule"></Schedule>
        <RecentSchedule v-if="isShow.recentSchedule" @child="getRecentScheduleEmitData" ref="quickRecentSchedule"></RecentSchedule>
        <Working v-if="isShow.working" :country-digit-code="countryDigitCode3" ref="quickWorking"></Working>
        <QuickCalcIssue
          v-show="isShow.calcIssue"
          ref="quickCalcIssue"
          @isLoadOk="isLoadOk"
          :country-digit-code="countryDigitCode3"
          @child="getCalcIssueData"
        ></QuickCalcIssue>
        <ManagerInfo v-if="isShow.managerInfo" :is-login="isLogin" :country-digit-code="countryDigitCode2" ref="quickManagerInfo"></ManagerInfo>
        <a href="javascript:void(0)" @click="quickClose()" class="quick_close"><span>close</span></a>
      </div>
      <!-- quick_box // -->
    </div>
    <!-- quick_wrap // -->
    <div id="quick_pop1">
      <win-layer-pop>
        <component
          v-if="customComponent1"
          :is="customComponent1"
          :parent-info="parentInfo"
          @child="getPopEmitData"
          @close="closePopWrap"
          :select-data.sync="selectData"
          :profile-list="profileList"
        />
      </win-layer-pop>
    </div>
    <div id="quick_pop2">
      <win-layer-pop>
        <component
          v-if="customComponent2"
          :is="customComponent2"
          :parent-info="parentInfo"
          @close="closePopWrap2"
        />
      </win-layer-pop>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { rootComputed, rootMethods } from '@/store/helpers'
import Profile from '@/components/layout/quick/Profile'
import Link from '@/components/layout/quick/Link'
import Menu from '@/components/layout/quick/Menu'
import ManagerInfo from '@/components/layout/quick/ManagerInfo'
import PromotionSchedule from '@/components/layout/quick/PromotionSchedule'
import Schedule from '@/components/layout/quick/Schedule'
import RecentSchedule from '@/components/layout/quick/RecentSchedule'
import Working from '@/components/layout/quick/Working'
import QuickCalcIssue from '@/components/layout/quick/QuickCalcIssue'
import ProfileApi from '@/api/rest/user/profile'
import SelectProfile from '@/components/layout/SelectProfile'
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'
import WinLayerPopWrap from '@/pages/trans/popup/WinLayerPopWrap'
import ScheduleComparePopType01 from '@/components/schedule/ScheduleComparePopType01'
import VesselScheduleInfoPop from '@/pages/schedule/popup/VesselScheduleInfoPop'/* 선박정보 및 스케줄 팝업 */
import VtlAccPop from '@/pages/settle/popup/VtlAccPop'
import BlDoPaymentPop from '@/pages/trans/popup/BlDoPaymentPop'
import api from '@/api/services/auth'
import countryCode from '@/plugins/country.json'
import CalcIssue from '@/api/rest/settle/calcIssue'
export default {
  name: 'Quick',
  components: {
    Profile,
    Link,
    Menu,
    ManagerInfo,
    PromotionSchedule,
    Schedule,
    RecentSchedule,
    Working,
    QuickCalcIssue,
    SelectProfile,
    WinLayerPop,
    WinLayerPopWrap,
    ScheduleComparePopType01,
    VesselScheduleInfoPop,
    VtlAccPop,
    BlDoPaymentPop
  },
  data: function () {
    return {
      compList: ['profile', 'link', 'menu', 'promotionschedule', 'schedule', 'recentSchedule', 'working', 'calcIssue', 'managerInfo'],
      isShow: {
        profile: true,
        link: true,
        menu: true,
        promotionschedule: false,
        schedule: false,
        recentSchedule: false,
        working: false,
        calcIssue: false,
        managerInfo: true
      },
      isQuickCalcIssueLoad: false,
      profileList: [],
      customComponent1: null,
      customComponent2: null,
      updateProfileIdx: null,
      selectData: [],
      parentInfo: {},
      loginResp: null,
      beforeLoginResp: null,
      linkTotalCnt: 0,
      countryCode: countryCode,
      countryDigitCode2: '',
      countryDigitCode3: '',
      userDmdInfo: {
        etDmdCatCd: '',
        imDmdCatCd: ''
      }
    }
  },
  computed: {
    isLogin () {
      return !this.isEmpty(store.state.auth.jwt)
    },
    path () {
      return this.$route.path
    },
    personalizedFlag () {
      return store.state.personalizedFlag
    },
    isOpenPersonalized () {
      return store.state.isOpenPersonalized
    },
    profile () {
      return store.state.auth.selectedProfile
    },
    ...rootComputed
  },
  watch: {
    path: function () {
      if (this.path !== '/main') {
        this.$store.commit('updateIsOpenPersonalized', false)
      }
    },
    profile: {
      deep: true,
      handler () {
        setTimeout(() => {
          this.getData()
        }, 500)
      }
    },
    personalizedFlag () {
      this.getData()
    },
    isOpenPersonalized () {
      if (this.isOpenPersonalized) {
        this.quickOpen()
      } else {
        this.quickClose()
      }
    }
  },
  created () {
  },
  mounted () {
    if (this.isLogin) {
      // GA dataLayer 추가
      globalThis.dataLayer[0].ga_user_id = this.auth.userId
      globalThis.dataLayer[0].is_login = 'Y'
      globalThis.dataLayer[0].id = this.auth.orgUserId
      globalThis.dataLayer[0].user_profile = this.auth.userName
      /*
      window.dataLayer.push({
        event: 'login',
        ga_user_id: this.auth.userId,
        user_contact_region: this.auth.userCtrCd,
        user_member_type: this.auth.cstCatCd,
        user_pic: this.profile.eiCatCd,
        is_login: 'Y',
        user_profile: this.auth.userName,
        id: this.auth.orgUserId
      })
      */
      this.getUserDmd()
      this.getUnsolved()
      // 변경 후 (단순화 + 안전)
      const ctrCd = this.isEmpty(this.auth.userCtrCd)
        ? (localStorage.getItem('service_ctrcd') || 'KR')
        : this.auth.userCtrCd
      this.countryDigitCode2 = countryCode[ctrCd].digitCode2
      this.countryDigitCode3 = countryCode[ctrCd].digitCode3

      // 진행중업무 새탭(팝업, 창 이름 'VUE_APP_NAME_bkgNo')으로 열린 창에서는 퀵메뉴 자동 오픈 생략
      if (!window.name.startsWith(process.env.VUE_APP_NAME + '_')) {
        this.quickOpen()
      }
    } else { // 브라우저 조건에 따라 판단(엣지, ...)
      // GA dataLayer 추가
      globalThis.dataLayer[0].ga_user_id = ''
      globalThis.dataLayer[0].is_login = 'N'
      globalThis.dataLayer[0].id = ''
      globalThis.dataLayer[0].user_profile = ''

      this.countryDigitCode2 = this.$ekmtcCommon.isEmpty(localStorage.getItem('service_ctrcd')) ? 'KR' : localStorage.getItem('service_ctrcd')
      this.countryDigitCode3 = this.$ekmtcCommon.isEmpty(localStorage.getItem('service_ctrcd')) ? 'KR' : localStorage.getItem('service_ctrcd')
    }
  },
  methods: {
    ...rootMethods,
    getUserDmd () {
      CalcIssue.getUserDmd({}, { spinner: false }).then(async response => {
        this.userDmdInfo = response.data
      }).catch(e => {
        this.userDmdInfo = {
          etDmdCatCd: '',
          imDmdCatCd: ''
        }
      })
    },
    isLoadOk (obj) {
      //
      this.isQuickCalcIssueLoad = true
    },
    getPopEmitData (data) {
      this.updateProfileIdx = null
      let isOkNotZero = true

      switch (data.type) {
        case 'close':
          this.$ekmtcCommon.layerClose('#quick_pop1 > .popup_dim')
          break
        case 'select':
          this.updateProfileIdx = data.payload.idx

          // 약관동의 항목 체크
          if (this.profileList[this.updateProfileIdx].mdtyPsnlInfCltnCnstYn !== 'Y') {
            // 선택한 프로필의 필수동의 체크
            isOkNotZero = false
          }

          // console.log('@@@@@ this.profileList[this.updateProfileIdx] ', this.profileList[this.updateProfileIdx])

          if (isOkNotZero) {
            this.changeProfileAlert()
          } else {
            this.$ekmtcCommon.layerClose('#quick_pop1 > .popup_dim')

            this.$router.push(
              {
                name: 'login-approval',
                params: {
                  checkView: 'changeProfile',
                  profile: this.profileList[this.updateProfileIdx]
                }
              })
              .catch(() => {})
          }
          break
        case 'openPop':
          this.parentInfo = data.payload.parentInfo
          this.customComponent2 = data.payload.compNm
          this.$ekmtcCommon.layerOpen('#quick_pop2> .popup_dim')
          break
        case 'addProfilePage':
          this.$ekmtcCommon.layerClose('#quick_pop1 > .popup_dim')

          store.commit('auth/updateIsEmptyProfileLogin', true)

          setTimeout(() => {
              this.$router.push(
                {
                  name: 'profile',
                  params: {
                      checkView: 'beforeProfile',
                      profile: 'N'
                  }
                })
          }, 100)

          break
      }
    },
    getRecentScheduleEmitData (data) {
      if (data.type === 'openPop') {
        this.selectData = data.payload.selectData
        this.customComponent1 = data.payload.compNm
        this.$ekmtcCommon.layerOpen('#quick_pop1 > .popup_dim')
      }
    },
    getMenuEmitData (data) {
      if (data.type === 'openPop') {
        this.customComponent1 = data.payload.compNm
        this.parentInfo = data.payload.parentInfo
        this.$ekmtcCommon.layerOpen('#quick_pop1 > .popup_dim')
      }
    },
    getProfileEmitData (data) {
      if (data.type === 'openSelectProfilePop') {
        this.getProfileList()
      }
    },
    getCalcIssueData (data) {
      if (data.type === 'openPop') {
        this.customComponent1 = data.payload.compNm
        this.$ekmtcCommon.layerOpen('#quick_pop1 > .popup_dim')
      }
    },
    getProfileList () {
      ProfileApi.getProfileList(sessionStorage.getItem('loginId'), this.auth.userCtrCd).then(response => {
        this.profileList = this.parseProfileList(response.data)
        this.customComponent1 = SelectProfile
        this.$ekmtcCommon.layerOpen('#quick_pop1 > .popup_dim')
      }).catch(e => {
        console.log(e)
      })
    },
    parseProfileList (arr) {
      let res = []
      let myIdx = null
      if (!this.isEmpty(this.selectedProfile)) {
        for (let i = 0; i < arr.length; i++) {
          if ((arr[i].picNo === this.selectedProfile.picNo) && (arr[i].cstCatCd === this.selectedProfile.cstCatCd)) {
            arr[i].isMe = true
            res.push(arr[i])
            myIdx = i
            break
          }
        }
      }

      if (myIdx != null) {
        arr.splice(myIdx, 1)
      }
      for (let item of arr) {
        res.push(item)
      }

      for (let item of res) {
        if (this.isEmpty(item.picPoto)) {
          item.picPotoString = null
        } else {
          let image = new Image()
          image.src = 'data:image/png;base64,' + item.picPoto
          item.picPotoString = image.src
        }
      }
      return this.orderByUseYnProfileList(res)
    },
    orderByUseYnProfileList (arr) {
      let res = []
      let noUseArr = []
      for (let p of arr) {
        if (p.useYn === 'N') {
          noUseArr.push(p)
        } else {
          res.push(p)
        }
      }

      for (let noUse of noUseArr) {
        res.push(noUse)
      }
      return res
    },
    changeProfileAlert () {
      let obj = {
            onConfirm: this.chagneProfile,
            customCloseBtnClass: 'button blue lg',
            customCloseBtnText: this.$i18n.t('msg.ONIM010P070.008'), // 취소
            customConfirmBtnText: this.$i18n.t('msg.MYIN050T010.056'), // 확인
            useConfirmBtn: true,
            customConfirmBtnClass: 'button blue lg',
            message: this.$i18n.t('msg.MYIN050T010.076'), // 프로필을 교체하시겠습니까? // WMH
            type: 'info'
          }
          this.$ekmtcCommon.alert(obj)
    },
    chagneProfile () {
        let req = {
          userId: this.profileList[this.updateProfileIdx].userId,
          jwt: this.$store.state.auth.loginInfo.jwt
        }

        // GA dataLayer 추가
        globalThis.dataLayer[0].user_profile = this.profileList[this.updateProfileIdx].picNm
        globalThis.dataLayer[0].ga_user_id = this.profileList[this.updateProfileIdx].userId
        globalThis.dataLayer[0].id = this.profileList[this.updateProfileIdx].preUserId
        globalThis.dataLayer[0].is_login = 'Y'

        globalThis.dataLayer.push({
          event: 'profile_change',
          ga_user_id: this.profileList[this.updateProfileIdx].userId,
          user_contact_region: this.profileList[this.updateProfileIdx].userCtrCd,
          user_member_type: this.profileList[this.updateProfileIdx].cstCatCd,
          user_pic: this.profileList[this.updateProfileIdx].eiCatCd,
          is_login: 'Y',
          user_profile: this.profileList[this.updateProfileIdx].picNm,
          id: this.profileList[this.updateProfileIdx].preUserId
        })

        // [[ pre user is 셋팅
        // profile pre_user_id 로 변경
        //console.log('idx>>>>>>>>>>>>>>>>>>>>>>>>>>>>', this.profileList)
        //console.log('this.profileList[idx].preUserId', this.profileList[this.updateProfileIdx])
        //console.log('sessionStorage.getItem(loginId)', sessionStorage.getItem('loginId'))
        if (!this.isEmpty(this.profileList[this.updateProfileIdx].preUserId) && sessionStorage.getItem('loginId') !== this.profileList[this.updateProfileIdx].preUserId) {
          sessionStorage.setItem('loginId', this.profileList[this.updateProfileIdx].preUserId)
          // [[ 로그인 추가 프로필 변경 시 user_id가 변경되면 재 로그인...
          let upperForm = {
              userId: this.profileList[this.updateProfileIdx].preUserId,
              userPwd: this.profileList[this.updateProfileIdx].preUserId
            }
          api.logInfo(upperForm).then(loginResp => {
            let respCode = loginResp.headers.respcode
            // console.log('loginResp==========>', loginResp)
            if (respCode === 'C0000') {
              this.beforeLoginResp = loginResp.data
              if (upperForm.userId.includes('EKMTC_')) {
                sessionStorage.setItem('cstCd', 'KMT013')
              } else {
                sessionStorage.setItem('cstCd', loginResp.data.cstCd)
              }
              sessionStorage.setItem('loginId', upperForm.userId)
              sessionStorage.setItem('logCatCd', loginResp.data.logCatCd)

              req.jwt = this.beforeLoginResp.data.jwt
            }
          }).catch(e => {
            console.log(e)
          })
        }
        // 로그인 추가 ]]
        api.profileLogin(req).then(resp => {
          if (this.isEmpty(this.beforeLoginResp)) {
            this.beforeLoginResp = JSON.parse(JSON.stringify(this.$store.state.auth.loginInfo))
          }
          this.loginResp = resp
          this.saveLoginData(this.updateProfileIdx)
        }).catch(e => {
          console.log(e)
        })
    },
    saveLoginData (profileIdx) {
      let respCode = this.loginResp.headers.respcode
      if (respCode === 'C0000') {
        this.saveLogin({
          user: this.loginResp.data,
          jwt: this.loginResp.data.jwt,
          refreshToken: this.loginResp.data.refreshToken,
          autoLogin: true,
          profile: this.profileList[profileIdx],
          loginInfo: this.beforeLoginResp
        }).then(() => {
          this.$store.commit('updatePersonalizedFlag')
          this.$ekmtcCommon.layerClose('#quick_pop1 > .popup_dim')
        }).catch(() => {
          let obj = {
            alertType: 'simple',
            customCloseBtnClass: 'button blue lg simplert-test1',
            customCloseBtnText: this.$i18n.t('msg.MYIN050T010.056'), // 확인
            useIcon: false,
            customClass: 'simple_alert',
            message: this.$i18n.t('msg.MYIN050T010.077'), // 프로필 교체에 실패했습니다. WMH
            type: 'info'
          }
          this.$ekmtcCommon.alert(obj)
          this.$ekmtcCommon.layerClose('#quick_pop1 > .popup_dim')
        })
      } else {
          let obj = {
            alertType: 'simple',
            customCloseBtnClass: 'button blue lg simplert-test1',
            customCloseBtnText: this.$i18n.t('msg.MYIN050T010.056'), // 확인
            useIcon: false,
            customClass: 'simple_alert',
            message: '프로필 교체에 실패했습니다.', // WMH
            type: 'info'
          }
          this.$ekmtcCommon.alert(obj)
          this.$ekmtcCommon.layerClose('#quick_pop1 > .popup_dim')
      }
    },
    quickOpen: function () {
      // 단위테스트 > (Web)MAIN_FOOTER_개인화_UTIL > 2번 비고 요청사항으로 추가하였습니다.
      this.$el.addEventListener('click', this.stopProp)
      document.body.addEventListener('click', this.quickClose)

      $('.quick_box').animate({ right: 0 })
      this.getIsShow()
    },
    quickClose: function () {
      // 단위테스트 > (Web)MAIN_FOOTER_개인화_UTIL > 2번 비고 요청사항으로 추가하였습니다.
      this.$el.removeEventListener('click', this.stopProp)
      document.body.removeEventListener('click', this.quickClose)

      $('.quick_box').animate({ right: -362 })
    },
    getUnsolved () {
      if (this.isShow.link) {
        if (this.isLogin && this.auth.staffFlag === 'N') {
          this.$refs.quickLink.getNewUnsolvedList()
        }
      }
    },
    async getData () {
      // Vue 가 isShow 변경에 따라 자식 컴포넌트들을 렌더링/마운트할 시간을 기다린 후 ref 호출
      this.$nextTick(() => {
        if (this.isShow.promotionschedule && this.$refs.PromotionSchedule) {
          this.$refs.PromotionSchedule.getPromotionSchedules()
        }
        if (this.isShow.schedule && this.$refs.quickSchedule) {
          this.$refs.quickSchedule.getSuggestionSchedules()
        }
        if (this.isShow.recentSchedule && this.$refs.quickRecentSchedule) {
          this.$refs.quickRecentSchedule.init()
        }
        if (this.isShow.working && this.$refs.quickWorking) {
          this.$refs.quickWorking.getWorkingCnt()
        }
        if (this.isShow.calcIssue && this.$refs.quickCalcIssue) {
          this.$refs.quickCalcIssue.init()
        }
        if (this.isShow.managerInfo && this.$refs.quickManagerInfo) {
          this.$refs.quickManagerInfo.getManagerInfo()
        }
      })
    },
    getIsShow () {
      let parentPath = this.getParentPath()
      for (let comp of this.compList) {
        switch (comp) {
          case 'profile':
            this.isShow.profile = true
            break
          case 'link':
            this.isShow.link = true
            break
          case 'menu':
            this.isShow.menu = !this.isLogin
            break
          case 'promotionschedule':
            this.isShow.promotionschedule = this.isLogin //(this.auth.userCtrCd === 'KR')
            break
          case 'schedule':
            this.isShow.schedule = this.isLogin
            break
          case 'recentSchedule':
            this.isShow.recentSchedule = (parentPath === 'schedule') && this.isLogin
            break
          case 'working':
            this.isShow.working = (parentPath === 'working') && this.isLogin
            break
          case 'calcIssue':
            this.isShow.calcIssue = (parentPath === 'calcIssue') && this.isLogin
            break
          case 'managerInfo':
            this.isShow.managerInfo = true
            break
        }
      }
      this.getData()
    },
    closePopWrap () {
      this.customComponent1 = null
      $('#quick_pop1 > .popup_dim').fadeOut()
    },
    closePopWrap2 () {
      this.customComponent2 = null
      $('#quick_pop2 > .popup_dim').fadeOut()
    },
    getParentPath () {
      let splitPath = this.$route.path.split('/')
      return splitPath[1]
    },
    isEmpty (value) {
      return value === '' || value === null || value === undefined || (typeof value === 'object' && !Object.keys(value).length)
    },
    // 단위테스트 > (Web)MAIN_FOOTER_개인화_UTIL > 2번 비고 요청사항으로 추가하였습니다.
    stopProp (e) {
      e.stopPropagation()
    }
  }
}
</script>
